import React, { useEffect, useState } from 'react';
import Button from 'src/components/controls/forms/redesign/FormButton';
import useFetch from 'use-http';
import DialogList from 'src/dialogs';
import { DocumentTypes } from 'src/models/DocumentTypes';
import moment from 'moment';
import DocumentManagement from 'src/components/layout/DocumentManagement';
import ConfirmDeleteDocDialog from 'src/components/project/sections/LeasingComponents/ConfirmDeleteDocDialog';

// TODO: For Testing, remove later

type fileDataType = {
    id: number;
    originalFileName: string;
    fileSize: number;
    fileExtension: string;
    fileType: string;
    s3FileId: number;
    s3KeyName: string;
    uploadDate: Date;
    note: string;
    docType: string;
    expirationDate: Date;
};

interface IReceiptDocsProps {
    showDialog: (dialogName: string) => void;
    hideDialog: () => void;
    hasOwnership: boolean;
    tractType?: 'Mineral' | 'Surface';
    userId?: number;
    ccTransactionId?: number;
}
const ReceiptDocs = (props: IReceiptDocsProps) => {
    const [fileData, setFileData] = useState(undefined);
    const [fileIdToDelete, setFileIdToDelete] = useState(undefined);
    const { get, request, response } = useFetch();

    const loadData = async () => {
        let filePath = `/v1.0/s3bucket/user/${props.userId}`;

        const data = await get(filePath);

        if (response.ok) {
            setFileData(data);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        loadData();
    }, [props.userId]);

    const downloadFile = async (keyName: string, index: number, fileName: string) => {
        await get(`/v1.0/s3bucket/${keyName}`);
        if (response.ok) {
            await response.blob().then((blob) => {
                const blobUrl = window.URL.createObjectURL(blob);
                const a = document.getElementById(`a_${index}`) as HTMLAnchorElement;
                a.href = blobUrl;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(blobUrl);
            });
        }
    };

    const deleteFile = async (s3FileId: number) => {
        if (!isNaN(s3FileId)) {
            setFileIdToDelete(s3FileId);
            props.showDialog(DialogList.DELETE_DOC);
        }
    };

    const deleteFileConfirmed = async () => {
        props.hideDialog();
        await request.delete(`/v1.0/s3bucket/${fileIdToDelete}`);
        setFileIdToDelete(undefined);
        loadData();
    };

    const deleteFileCanceled = () => {
        props.hideDialog();
        setFileIdToDelete(undefined);
    };

    const filterFileData = () => {
        let data = fileData as fileDataType[];

        if (data) {
            return data.filter(d => d.docType === '25');
        }

        return fileData;
    };

    const docType = (docTypeValue: string) => {
        const numDocType = parseInt(docTypeValue, 10);
        if (numDocType) {
            const type = DocumentTypes.find((dc) => dc.id === numDocType) || { name: 'Bad Doc Type' };
            return type;
        }
        return { name: 'No Doc Type Set' };
    };

    const displayFiles = () => {
        if (fileData) {
            return filterFileData().map((file: fileDataType, index: number) => {
                return (
                    <div
                        key={index}
                        style={{ display: 'flex', borderBottom: '1px solid darkgrey' }}
                        className="mb-2"
                    >
                        <div style={{ width: '35%', textAlign: 'left' }}>{docType(file.docType).name}</div>
                        <div style={{ width: '20%', textAlign: 'left' }}>{moment(file.uploadDate).format('MM-DD-YYYY')}</div>
                        <div style={{ width: '35%', textAlign: 'left' }}>{file.note}</div>
                        <div style={{ width: '5%', textAlign: 'left' }}>
                            <a onClick={() => downloadFile(file.s3KeyName, index, file.originalFileName)}>
                                <i style={{ fontSize: '1.7rem' }} className="far fa-download mr-1 clickable" />
                            </a>

                            <a onClick={() => deleteFile(file.id)} style={{ color: 'red' }}>
                                <i style={{ fontSize: '1.7rem' }} className="far fa-trash mr-1 clickable" />
                            </a>
                        </div>
                        <a id={`a_${index}`} />
                    </div>
                );
            });
        } else {
            return <div>No Files Found</div>;
        }
    };

    const filesUploaded = () => {
        props.hideDialog();
        loadData();
    };

    return (
        <>
            <div>

                <div>
                    <div>
                        {/* <div style={{ fontSize: '1.75rem' }}>A/P Voucher Receipts</div> */}
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: '35%', textAlign: 'left', fontSize: '1.6rem', fontWeight: 'bold' }}>Document Name</div>
                            <div style={{ width: '20%', textAlign: 'left', fontSize: '1.6rem', fontWeight: 'bold' }}>Upload Date</div>
                            <div style={{ width: '35%', textAlign: 'left', fontSize: '1.6rem', fontWeight: 'bold' }}>Note</div>
                            <div style={{ width: '5%', textAlign: 'left', fontSize: '1.6rem', fontWeight: 'bold' }}>Actions</div>
                        </div>
                        <hr />
                        <div style={{ maxHeight: '10rem', overflowY: 'scroll' }}>{displayFiles()}</div>
                    </div>

                </div>
                <Button
                    className="blue-hover-button"
                    style={{marginRight: '1rem'}}
                    text="Attach Document"
                    size="medium"
                    intent="primary"
                    onClick={() => props.showDialog(DialogList.DOCUMENT_MANAGEMENT)}
                />
            </div>
            <DocumentManagement
                filesUploaded={filesUploaded}
                context={'receipt'}
                contractLookupId={props.ccTransactionId}
                userId={props.userId}
            />
            <ConfirmDeleteDocDialog confirmDelete={deleteFileConfirmed} cancelDelete={deleteFileCanceled} />
        </>
    );
};

export default ReceiptDocs;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/pages/ReceiptDocs.tsx